import { render, staticRenderFns } from "./PriceSection.vue?vue&type=template&id=5bfcc51c&scoped=true"
import script from "./PriceSection.vue?vue&type=script&lang=js"
export * from "./PriceSection.vue?vue&type=script&lang=js"
import style0 from "./PriceSection.vue?vue&type=style&index=0&id=5bfcc51c&prod&lang=scss"
import style1 from "./PriceSection.vue?vue&type=style&index=1&id=5bfcc51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfcc51c",
  null
  
)

export default component.exports